export default {
  HeaderTitle: 'Risk Liquidity',
  Title      : 'Liquidity',
  Tab        : {
    Monitoring: {
      Title: 'Risk Monitoring',
      Slug : 'monitoring'
    },
    DeferenceReadiness: {
      Title: 'Defence Readiness',
      Slug : 'defence-readiness'
    },
    BankFailures: {
      Title: 'Bank Failures',
      Slug : 'bank-failures'
    },
    BankRunBenchmarking: {
      Title: 'Bank Run Benchmarking',
      Slug : 'bank-run-benchmarking'
    }
  },
  Section: {
    BankRunBenchmarking: {
      InfoTip: 'MISSING TOOLTIP'
    },
    LiquidityRiskAssessment: {
      Title     : 'Liquidity Risk Assessment',
      Tooltip   : 'MISSING TOOLTIP',
      RiskScore : 'Risk Score',
      BankSector: 'Bank Sector'
    },
    KeyLiquidityRatios: {
      Title      : 'Key Liquidity Ratios',
      Tooltip    : 'MISSING TOOLTIP',
      Description: 'Current Value & Last 12 months change',
      Current    : 'Current',
      Ratio      : 'Ratio'
    },
    RealTimeMonitoring: {
      Title  : 'Real Time Monitoring',
      Tooltip: 'MISSING TOOLTIP',
      Blocks : {
        SocialMediaMentions: {
          Title   : 'Social Media Index',
          Subtitle: 'Last 30 days'
        },
        MarketPriceAction: {
          Title  : 'Market Price Action',
          Tooltip: 'S&P Medium Bank Equity Index',
          Filters: {
            Last7Days  : 'Last week',
            Last30Days : 'Last month',
            Last6Months: 'Last 6 Months'
          },
          Change: 'Change'
        }
      }
    },
    BankFailures: {
      Title : 'Bank Failures',
      NoData: 'No data available',
      Blocks: {
        USBankFailures: {
          Title   : 'US Bank Failures',
          InfoTip : 'MISSING TOOLTIP',
          Change  : 'Change',
          Failures: 'failures',
          Failure : 'failure',
          Filters : {
            Total: 'Total'
          },
          Toggles: {
            TotalValueOfAssets: 'Total Value of Assets',
            AmountOfFailures  : 'Number of Failures',
            HideAnnotations   : 'Hide Annotations',
            ShowAnnotations   : 'Show Annotations'
          }
        },
        ListOfUSBankFailures: {
          Title  : 'List of US Bank Failures',
          Filters: {
            All        : 'All',
            SelectCity : 'Select City',
            SelectState: 'Select State',
            SelectYear : 'Select Year',
            SortedBy   : {
              Title : 'Sorted by',
              Toggle: {
                FailureDate  : 'Failure Date',
                ValueOfAssets: 'Value of Assets'
              }
            }
          },
          TableHeaders: {
            Date       : 'Date',
            Bank       : 'Bank',
            Established: 'Established',
            City       : 'City',
            State      : 'State',
            Assets     : 'Assets'
          }
        }
      }
    },
    DefenceReadiness: {
      Button: {
        Title: 'Run Edited Scenario'
      },
      CrisisScenarios: {
        Title    : 'Crisis Scenarios',
        InfoTip  : 'MISSING TOOLTIP',
        Scenarios: {
          Panic: {
            Title: 'Panic Mode',
            Bank : 'Silicon Valley Bank, Northern Rock, Bankia',
            Type : 'Panic',
            Color: 'synthesis-ui-red-04'
          },
          Severe: {
            Title: 'Severe Crisis',
            Bank : 'First Republic IndyMac',
            Type : 'Severe',
            Color: 'synthesis-ui-orange-03'
          },
          Mild: {
            Title: 'Mild Crisis',
            Bank : 'Signature Bank Western Alliance',
            Type : 'Mild',
            Color: 'synthesis-ui-yellow-01'
          }
        }
      },
      DefenceReadinessOutcome: {
        Title                : 'Defence Readiness Outcome in #',
        EditedScenarioTitle  : 'Edited Scenario Outcome',
        SurvivalDays         : 'Survival Days',
        SurvivalDaysWithdrawn: 'Deposits Outflow by Day 10',
        SurvivalDaysDeployed : 'Funds Deployed by Day 10',
        Days                 : 'days'
      },
      MildCrisisAssumptions: {
        Title         : 'Mild Crisis Assumptions',
        CrisisScenario: {
          Mild  : 'Mild Crisis Assumptions',
          Severe: 'Severe Crisis Assumptions',
          Panic : 'Panic Crisis Assumptions'
        },
        EditedScenarioTitle       : 'Edited Scenario Assumptions',
        Insured                   : 'Insured',
        Uninsured                 : 'Uninsured',
        DemandDeposits            : 'Demand Deposits',
        SavingsDeposits           : 'Savings Deposits',
        TimeDeposits              : 'Time Deposits',
        TotalOutflow              : 'Total Outflow per Day',
        CrisisDays                : 'Crisis Day',
        WithdrawalPerDayPercentage: 'Withdrawal per Day (%)',
        WithdrawalsPerDayDollars  : 'Withdrawals per Day ($)',
        NumberOfDaysUnderCrisis   : 'Crisis Day',
        DeploymentPerDay          : 'Deployment Per Day ( % )',
        FinancialInstruments      : 'Financial Instruments',
        DepositCategories         : 'Deposit Categories',
        availableCash             : {
          Title: 'Available Cash',
          Color: '--v-synthesis-ui-green-04-base'
        },
        publicBrokeredDeposit: {
          Title: 'Public/Brokered Deposit',
          Color: '--v-synthesis-ui-yellow-04-base'
        },
        fhlbLine: {
          Title: 'FHLB Line',
          Color: '--v-synthesis-ui-purple-02-base'
        },
        interbankGroupLine: {
          Title: 'Interbank/Group Line',
          Color: '--v-synthesis-ui-orange-03-base'
        },
        fedDiscountWindow: {
          Title: 'Fed Discount Window',
          Color: '--v-synthesis-ui-blue-04-base'
        },
        investments: {
          Title: 'Investments',
          Color: '--v-synthesis-ui-red-04-base'
        },
        loanSale: {
          Title: 'Loans Portfolio Sale',
          Color: '--v-synthesis-ui-green-02-base'
        },
        TotalAmountOfFunds     : 'Total Funds',
        DefenceReadinessOutcome: 'Defence Readiness Outcome: Survival Days',
        DeployedPerDay         : 'Deployed Per Day',
        WithdrawnPerDay        : 'Withdrawn Per Day',
        CumulativeWithdrawns   : 'Cumulative Withdrawals',
        AmountOf               : 'Amount of',
        TabSelector            : {
          DepositorBehavior: {
            Title: 'Depositor Behavior',
            Svg  : `<svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.40012 19V16.5884H6.35736H4.80095C4.35479 16.5773 3.93067 16.3922 3.61911 16.0726C3.30755 15.7531 3.13323 15.3244 3.13337 14.8781V12.4665L1.5 11.6541L3.12482 8.39591V7.85715C3.08722 6.15702 3.69543 4.50583 4.82688 3.23631C5.95834 1.9668 7.52893 1.17333 9.22217 1.01581C10.1149 0.953477 11.0108 1.07592 11.854 1.37549C12.6973 1.67505 13.4697 2.1453 14.1229 2.75685C14.7762 3.3684 15.2964 4.10811 15.6509 4.92976C16.0054 5.75141 16.1866 6.63734 16.1832 7.53219C16.1835 9.82149 15.3085 12.0243 13.7375 13.6894V19" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M9.65818 10.8332C11.009 10.8332 12.104 9.7382 12.104 8.38743C12.104 7.03666 11.009 5.94165 9.65818 5.94165C8.30742 5.94165 7.2124 7.03666 7.2124 8.38743C7.2124 9.7382 8.30742 10.8332 9.65818 10.8332Z" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M9.6582 5.12061V5.94157" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M9.6582 11.6542V10.8333" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M6.83643 6.75391L7.53766 7.16439" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M12.4891 10.0208L11.7793 9.61035" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M12.4891 6.75391L11.7793 7.16439" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
<path d="M6.83643 10.0208L7.53766 9.61035" stroke="#63747D" stroke-miterlimit="10" stroke-linecap="square"/>
</svg>
`
          },
          BankReadiness: {
            Title: 'Bank Readiness',
            Svg  : `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.9999 16.875C6.98067 16.4726 5.16335 15.3827 3.85739 13.7909C2.55144 12.1992 1.83759 10.2039 1.8374 8.145V2.5575L8.9999 1.125L16.1624 2.5575V8.145C16.1622 10.2039 15.4484 12.1992 14.1424 13.7909C12.8365 15.3827 11.0191 16.4726 8.9999 16.875Z" stroke="#63747D" stroke-miterlimit="10"/>
<path d="M5.42236 8.19753L8.10736 10.8825L12.5774 6.40503" stroke="#63747D" stroke-miterlimit="10"/>
</svg>
`
          }
        },
        ViewSelector: {
          Modular: 'Modular View',
          Table  : 'Table View'
        },
        ModeSelector: {
          Default: 'Default Crisis Mode',
          Edit   : 'Edit Mode'
        }
      }
    }
  }
}
